import {Dialog, Transition} from '@headlessui/react'
import React, {Fragment, useImperativeHandle, useRef, useState} from 'react'
import IconClose from '@svg/common/ic_close.svg'
import IconCloseMobile from '@svg/gnb/ic_mo_close.svg'
import WizIcon from '@component/images/WizIcon'

interface IProps {
    children?: React.ReactNode
    className?: string
    closeIconClassName?: string
    headerColorClassName?: string
}

const NavModal = ({className, headerColorClassName, children, closeIconClassName}: IProps, ref: any) => {
    const [isOpen, setIsOpen] = useState(false)
    const completeButtonRef = useRef(null)

    useImperativeHandle(ref, () => ({
        show: () => {
            showModal()
        },
        close: () => {
            closeModal()
        },
    }))

    const closeModal = () => {
        setIsOpen(false)
    }

    const showModal = () => {
        setIsOpen(true)
    }

    return (
        <>
            <Dialog
                open={isOpen}
                as="div"
                className="fixed z-modal"
                onClose={closeModal}
                initialFocus={completeButtonRef}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed overflow-y-auto overflow-x-hidden top-0 right-0 h-full">
                    <div className={`flex min-h-full items-center justify-center p-0`}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-[200ms]"
                            enterFrom="-right-[230px]"
                            enterTo="right-0"
                            leave="ease-in duration-[150ms]"
                            leaveFrom="right-0"
                            leaveTo="-right-[270px]">
                            <Dialog.Panel
                                ref={completeButtonRef}
                                className={`transform bg-white dark:bg-bg_dark_popup shadow-xl min-h-screen relative min-w-[270px] ${className}`}>
                                <div className={`flex justify-end items-center p-[20px] ${headerColorClassName}`}>
                                    <WizIcon
                                        onClick={closeModal}
                                        backgroundColorClassName={
                                            'hover:bg-transparent01 dark:hover:bg-dark_transparent01 p-[4px] md:hover:bg-transparent cursor-pointer'
                                        }>
                                        <IconClose
                                            className={`w-[20px] fill-gray02 dark:fill-dark_gray02 md:hidden ${closeIconClassName}`}
                                        />
                                        <IconCloseMobile
                                            className={`w-[24px] fill-gray01 dark:fill-dark_gray01 hidden md:block ${closeIconClassName}`}
                                        />
                                    </WizIcon>
                                </div>
                                <div>{children}</div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default React.forwardRef(NavModal)
